import { render, staticRenderFns } from "./ExtendOtherNutrientsVitaminC.vue?vue&type=template&id=13a566e2&scoped=true"
import script from "./ExtendOtherNutrientsVitaminC.vue?vue&type=script&lang=ts"
export * from "./ExtendOtherNutrientsVitaminC.vue?vue&type=script&lang=ts"
import style0 from "./ExtendOtherNutrientsVitaminC.vue?vue&type=style&index=0&id=13a566e2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13a566e2",
  null
  
)

export default component.exports